module.exports = __webpack_public_path__ + "img/10.d7099410.png";